<template>
  <div class="progress-circular-wrapper">
    <v-progress-circular
      v-show="time > 0"
      :width="4"
      :rotate="-90"
      :value="timeValue"
      :class="contdownClasses"
      class="rounded-circle"
    >
      {{ normalizedTimeLeft }}
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "progress-countdown-display",
  props: {
    time: {
      type: Number,
      default: 25,
    },
    timeLeft: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    normalizedTimeLeft() {
      return this.timeLeft >= 0 ? this.timeLeft : 0;
    },
    timeValue() {
      return (this.normalizedTimeLeft / this.time) * 100;
    },
    contdownClasses() {
      return {
        "white red--text": this.normalizedTimeLeft < 10,
        "white--text": this.normalizedTimeLeft >= 10,
      };
    },
  },
};
</script>

<style lang="scss">
.progress-circular-wrapper {
  background: rgb(0 0 0 / 12%);
  padding: 5px;
  border-radius: 50%;
  height: 42px;
  width: 42px;
  font-size: 11px;
  box-shadow: 0 0 0 0 #607d8b;
  animation: pulsante 1.25s infinite;
}
</style>
